import { LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { setBaseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'


@customElement('csc-enterprise-domains')
export class CSCEnterpriseDomains extends LitElement {
  @property({ attribute: 'base-url', type: String })
  set baseUrl(value: string) { setBaseUrl(value) }
}
